import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Knowledge from './Knowledge-static'
import Instruction from './Instruction-static'
import Installation from './Installation-static'
import Card from './Card-static'
import HeadLineSlot from './HeadLineSlot-static'


const HomeTopBlock = ({ ...props }) =>
  <Media.Desktop>
    <Wrapper>
      <HeadLineSlot />
      <Instruction />
      <Knowledge />
      <Installation />
      <Card />
    </Wrapper>
  </Media.Desktop>


HomeTopBlock.propTypes = {
  '@type': PropTypes.string,
  'endeca:auditInfo': PropTypes.shape({
    'ecr:innerPath': PropTypes.string,
    'ecr:resourcePath': PropTypes.string
  }),
  name: PropTypes.string
}

HomeTopBlock.type = 'HomeTopBlock'

export default HomeTopBlock


const Wrapper = styled.div`
  background-size: cover;
`
